function pr_produkty() {
  //var $produkty;
  $(".products").each(function() {
    $(this)
      .find(".product")
      .each(function(index) {
        //$produkty = $(this).parent();

        if (!index && $(this).find(".cnt").length) return false;

        $('<div class="cnt"></div>').insertAfter($(this).find("a.name"));
        var $c = $(this).find(".cnt");

        $(this)
          .find(".prices")
          .appendTo($c);
        $(this)
          .find(".availability")
          .appendTo($c);
      });
  });
} //function  pr_produkty()

export function upravProdukty() {
  pr_produkty();

  document.addEventListener("ShoptetDOMContentLoaded", function() {
    pr_produkty();
  });
} //export function  upravProdukty()
